import script from "./HomeApproche.vue?vue&type=script&setup=true&lang=js"
export * from "./HomeApproche.vue?vue&type=script&setup=true&lang=js"

import "./HomeApproche.vue?vue&type=style&index=0&id=6edb33ed&lang=scss"

const __exports__ = script;

export default __exports__